module.exports = __webpack_public_path__ + "static/media/gain.6d6cd38f.png";